import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { Button } from '@scale/scaleui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Display a success toast when an issue is created successfully.
 *
 * @param title Title of the issue.
 * @param linearUrl URL of the Linear issue.
 * @param slackTeamName Name of team in Slack responsible for the issue, e.g. @gen-ai-ops-app-eng
 * @param slackChannelUrl URL of the Slack channel where tickets are sent.
 */
export function successToast(
  title: string,
  linearUrl: string,
  slackTeamName: string,
  pagerDutyTeamName: string,
) {
  toast.success(
    <ToastContent
      title={title}
      linearUrl={linearUrl}
      slackTeamName={slackTeamName}
      pagerDutyTeamName={pagerDutyTeamName}
    />,
    {
      closeOnClick: false,
      closeButton: CloseButton, // Default close button shrinks depending on toast content, so we use a custom one.
    },
  );
}

type ToastContentProps = {
  title: string;
  linearUrl: string;
  slackTeamName: string;
  pagerDutyTeamName: string;
};

const ToastContent: FC<ToastContentProps> = ({
  title,
  linearUrl,
  slackTeamName,
  pagerDutyTeamName,
}) => {
  return (
    <div className="scaleui scale-theme scale-tailwind flex flex-col px-1">
      Issue created successfully!
      <br />
      <br />
      <strong>"{title}"</strong>
      <br />
      <span>
        {pagerDutyTeamName
          ? `Someone from ${pagerDutyTeamName} or ${slackTeamName} will be in touch with next steps shortly.`
          : `Someone from ${slackTeamName} will be in touch with next steps shortly.`}
      </span>
      <div className="flex gap-4">
        <Button
          className="mt-4 w-fit"
          variant="neutral"
          onClick={() => window.open(linearUrl, '_blank')}
        >
          View on Linear
        </Button>
      </div>
    </div>
  );
};

type CloseButtonProps = {
  closeToast: (e: any) => void;
};

const CloseButton: FC<CloseButtonProps> = ({ closeToast }) => (
  <FontAwesomeIcon
    icon={['fas', 'times']}
    className="scale-tailwind cursor-pointer"
    onClick={e => closeToast(e)}
    size="lg"
  />
);
